import { AuthModule } from "@/store/modules/auth";
import { ENDPOINT_GAE, ENDPOINT_TRANSLATE } from "@/env";

export const RESULT_OK = "ok";
export const RESULT_ERROR = "error";

const API_URL = ENDPOINT_GAE;

export async function get(path: string) {
  const url = API_URL + "/" + path;

  await AuthModule.getIdToken();
  const token = AuthModule.idToken;
  const currentBoard = AuthModule.currentBoard;

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  };
  if (AuthModule.isAdminUser && currentBoard != null) {
    Object.assign(headers, { "customer-id": currentBoard.data.customerId });
  }

  return fetch(url, {
    method: "GET",
    headers: headers,
  });
}

export async function post(path: string, payload: string) {
  const url = API_URL + "/" + path;

  await AuthModule.getIdToken();
  const token = AuthModule.idToken;
  const currentBoard = AuthModule.currentBoard;

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  };
  if (AuthModule.isAdminUser && currentBoard != null) {
    Object.assign(headers, { "customer-id": currentBoard.data.customerId });
  }

  return fetch(url, {
    method: "POST",
    headers: headers,
    body: payload,
  });
}

export async function del(path: string) {
  const url = API_URL + "/" + path;

  await AuthModule.getIdToken();
  const token = AuthModule.idToken;
  const currentBoard = AuthModule.currentBoard;

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  };
  if (AuthModule.isAdminUser && currentBoard != null) {
    Object.assign(headers, { "customer-id": currentBoard.data.customerId });
  }

  return fetch(url, {
    method: "DELETE",
    headers: headers,
  });
}

export async function getTranslate(text: string) {
  let apikey = "";
  const currentBoard = AuthModule.currentBoard;
  if (currentBoard != null && currentBoard.data.services.vulnTracker != null) {
    apikey = currentBoard.data.services.vulnTracker;
  }

  const url = ENDPOINT_TRANSLATE + "?key=" + apikey;
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      source: "en",
      target: "ja",
      q: text,
    }),
  });
}
